import React, { useEffect,useState } from "react";
import { TasksAPIService } from "../../services/api/TasksAPIService";
import { useParams} from "react-router-dom";
import { CircularProgress, Box, Typography } from "@mui/material";


const RedirectURL = () => {
  const { code:shortCode,phoneNumber } = useParams();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    redirect();
  }, []);
  const redirect = () => {
    TasksAPIService.getListLink(shortCode,phoneNumber)
      .then((response) => {
        window.location.href = response?.url;
      })
      .catch((errResponse) => {
        console.log("errResponse", errResponse);
        setError(true);
        setLoading(false);
      });
  };

  return (
    <Box
    height="100vh"
    display="flex"
    justifyContent="center"
    alignItems="center"
    flexDirection="column"
  >
    {loading ? (
      <>
        <CircularProgress />
        <Typography mt={2}>Redirecting, please wait...</Typography>
      </>
    ) : (
      <Typography color="error">Failed to redirect. Please try again later.</Typography>
    )}
  </Box>
  );
};

export default RedirectURL;
